/**
 * Created by marccurry on 2/27/16.
 */
(function ($) {
    'use strict';
    /**
     * Prevent clicking on any menu parent item since that will prevent dropdown on
     * touch. instead, add class
     *
     * */


    /*     $('header.main nav .menu-item-has-children>a').click(function (e) {
        e.preventDefault();
        var $li = $(this).closest('li');

        if (!$li.hasClass('active')) {
            $li.addClass('active');
        } else {
            $li.removeClass('active');
        }

    });



    $('#fixed-nav li.menu-item-has-children>a').click(function (e) {


        e.preventDefault();
        var $li = $(this).closest('li');


        if (!$li.hasClass('active')) {
            $li.addClass('active').find('ul').slideDown();
        } else {
            $li.removeClass('active').find('ul').slideUp();
        }


    });

*/

    $('#search-button').click( function(){

        var $target = $("#search-wrapper");

        if( $target.hasClass('open')){

            $target.removeClass('open');
        }else{

            $("#search-input").focus();
            $target.addClass('open');

        }

    })

})( jQuery );
